import React, { Component } from 'react';
import { Route, Redirect } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { ApplicantList } from './components/Applicant/ApplicantList';
import { Cases } from './components/Cases/Cases';
import { Applicant } from './components/Applicant/Applicant';
import { Profile } from './components/Profile';
import { AutoCallDashboard } from './components/AutoCall/AutoCallDashboard';
import Auth from './components/Auth/Auth';
import Agency from './components/Agency/Agency';
import Callback from './callback';
import ExpiredAccess from './components/Auth/ExpiredAccess';
import { ApplicantDetails } from './components/Applicant/ApplicantDetails';
import Resources from './components/MoreResources/Resources';


export default class App extends Component {
    constructor(props) {
        super(props);

        this.auth = new Auth(this.props.history);
    }

    displayName = App.name

    render() {
        return (
            <Layout auth={this.auth}>

                <Route exact path='/' render={props =>
                    <Home auth={this.auth} {...props} />} />

                <Route exact path='/expired' render={props =>
                    <ExpiredAccess auth={this.auth} {...props} />} />

                <Route exact path='/resources' render={props =>
                    <Resources auth={this.auth} {...props} />} />

                <Route path='/callback' render={props =>
                    <Callback auth={this.auth} {...props} />} />

                <Route path='/applicantList' render={props =>
                    this.auth.isAuthenticated() ?
                        <ApplicantList auth={this.auth} {...props} />
                        : <Redirect to="/" />} />

                <Route exact path='/applicant/' render={props =>
                    this.auth.isAuthenticated() ?
                        <Applicant auth={this.auth} {...props} />
                        : <Redirect to="/" />} />

                <Route exact path='/applicant/:id' render={props =>
                    this.auth.isAuthenticated() ?
                        <Applicant auth={this.auth} {...props} />
                        : <Redirect to="/" />} />

                <Route exact path='/applicantDetails/:applicantId' render={props =>
                    this.auth.isAuthenticated() ?
                        <ApplicantDetails auth={this.auth} {...props} />
                        : <Redirect to="/" />} />

                <Route path='/cases' render={props =>
                    this.auth.isAuthenticated() ?
                        <Cases auth={this.auth} {...props} />
                        : <Redirect to="/" />} />

                <Route path='/autoCallDashboard' render={props =>
                    this.auth.isAuthenticated() ?
                        <AutoCallDashboard agency={this.agency} auth={this.auth} {...props} />
                        : <Redirect to="/" />} />

                <Route path='/profile'
                    render={props => this.auth.isAuthenticated() ? <Profile auth={this.auth} {...props} />
                        : <Redirect to="/" />
                    } />

                <Route path='/agency' render={props =>
                    this.auth.isAuthenticated() ? <Agency auth={this.auth} {...props} />
                        : <Redirect to="/" />} />
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js